@if (isLoadingRegisterUserData()) {
  <app-loader-1 />

} @else if(registerUser()) {
  @if (isLoadingFirstCustomRoute()) {
    
    @if(isMobile() && isGeolocationView()) {
      <app-geolocation-request />
    } @else {
      <app-loader-carousel />
    }
    
  } @else {
    <main class="route-container__register-user">
      <form
        #formRef
        class="register-user__form" 
        [formGroup]="form"
      >
       @if (isMobile()) {
        <app-register-user-form-mobile 
          [form]="form"
          (submitFormEmitter)="handleSubmit()"
        />
        
       } @else {
        <app-register-user-form-desktop 
          [form]="form"
          (submitFormEmitter)="handleSubmit()"
        />
       }
      </form>  
    </main>
  }
  
} @else {
  <main class="route-container__register-user">
    <div class="register-user__error-message">
      <p class="register-user__error-text">
        {{ 'No se ha podido cargar el formulario de registro. Por favor, inténtalo de nuevo más tarde.' | translate }}
      </p>
    </div>
  </main>
}